import React, { useEffect } from 'react';
import { Box, Container } from '@material-ui/core';

import { ButtonLink, GuestRelationsForm, ResponsiveContainer, useObservable } from '@lib/common';
import { ChangePasswordComponent, GuestProfileForm, PaymentMethodsForm } from '../components';
import { guestProfileQuery, guestProfileService } from '@lib/state';

export const MyAccountPage: React.FC = () => {
  const guest = useObservable(guestProfileQuery.guest, 'async');

  useEffect(() => {
    guestProfileService.getGuestProfile();
  }, []);

  if (!guest) return null;

  return (
    <ResponsiveContainer>
      <GuestProfileForm guest={guest} />
      <GuestRelationsForm guest={guest} />
      <PaymentMethodsForm />
      <ChangePasswordComponent />
      <Box my={2} clone>
        <Container maxWidth="lg">
          <ButtonLink to="/account/signout" variant="contained" color="secondary">
            Log Out
          </ButtonLink>
        </Container>
      </Box>
    </ResponsiveContainer>
  );
};
